import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ConfigProvider } from "@/lib/config";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import DemoLogin from "@/pages/DemoLogin";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import SuperAdmin from "@/pages/SuperAdmin";
import Convenios from "@/pages/Convenios";
import ConvenioDetail from "@/pages/ConvenioDetail";
import ConvenioNew from "@/pages/ConvenioNew";
import Acciones from "@/pages/Acciones";
import AccionesBulk from "@/pages/AccionesBulk";
import Usuarios from "@/pages/Usuarios";
import Facultades from "@/pages/Facultades";
import Unidades from "@/pages/Unidades";
import Estructuras from "@/pages/Estructuras";
import Configuracion from "@/pages/Configuracion";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function RootRoute() {
  const { user } = useAuth();
  if (user) {
    if (user.role === "superadmin") return <Navigate to="/superadmin" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfigProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<RootRoute />} />
              <Route path="/login" element={<Login />} />
              <Route path="/demo" element={<DemoLogin />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/superadmin"
                element={
                  <Protected roles={["superadmin"]}>
                    <SuperAdmin />
                  </Protected>
                }
              />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/convenios" element={<Protected><Convenios /></Protected>} />
              <Route path="/convenios/new" element={<Protected roles={["admin"]}><ConvenioNew /></Protected>} />
              <Route path="/convenios/:id" element={<Protected><ConvenioDetail /></Protected>} />
              <Route path="/acciones" element={<Protected><Acciones /></Protected>} />
              <Route path="/acciones/new" element={<Protected roles={["admin", "facultad", "unidad"]}><Acciones /></Protected>} />
              <Route path="/acciones/bulk" element={<Protected roles={["admin", "facultad", "unidad"]}><AccionesBulk /></Protected>} />
              <Route path="/admin/usuarios" element={<Protected roles={["admin"]}><Usuarios /></Protected>} />
              <Route path="/admin/facultades" element={<Protected roles={["admin"]}><Facultades /></Protected>} />
              <Route path="/admin/unidades" element={<Protected roles={["admin"]}><Unidades /></Protected>} />
              <Route path="/admin/estructuras" element={<Protected roles={["admin"]}><Estructuras /></Protected>} />
              <Route path="/admin/configuracion" element={<Protected roles={["admin"]}><Configuracion /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
